import React, { Component } from "react";
import {
  Container,
  Image,
  Modal,
  Button,
  Form,
  Dropdown,
  Row,
  Col,
  DropdownButton,
  Pagination,
} from "react-bootstrap";
import NavbarComponent from "../Navbar/index";
import RenovateTokenAlert from "../../RenovateToken";
import ChangePlanAlert from "../../ChangePlan";
import Backend from "../../Backend";
import ReactNotification from "react-notifications-component";
import AccountOverviewComponent from "./AccountOverview";
import PlanInformationComponent from "./PlanInformation";
import TransferModal from "./transferModal";
import RequestTranferModal from "./RequestTransferModal";
import SearchImage from "../../Images/search-blue.svg";
import RefreshImage from "../../Images/refresh.svg";
import { store } from "react-notifications-component";
import Connection from "../../Calls";
import { Bounce } from "react-activity";
import Contract from "../KycForm/components/contract";
import TransactionArrow from "./icons/transaction_arrows.svg";
import STPModal from "./STPModal/STPModal";
import translateWallet from "./translateWallet";

// var HeightScreen = window.screen.height;
function formatMoney(n, c, d, t) {
  var n = n,
    c = isNaN((c = Math.abs(c))) ? 2 : c,
    d = d == undefined ? "." : d,
    t = t == undefined ? "," : t,
    s = n < 0 ? "-$" : "$",
    i = String(parseInt((n = Math.abs(Number(n) || 0).toFixed(c)))),
    j = (j = i.length) > 3 ? j % 3 : 0;
  return (
    s +
    (j ? i.substr(0, j) + t : "") +
    i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) +
    (c
      ? d +
        Math.abs(n - i)
          .toFixed(c)
          .slice(2)
      : "")
  );
}

var searchTimeout;
class WalletsIndex extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: this.props.data.history?.location?.state?.modal_wallet || false,
      showModalTransfer: new window.URL(window.location.href).searchParams.get(
        "alias"
      ),
      showModalRequestTransfer: false,
      showModalSTP: false,
      coinSelect: props.traductions.wallets.Index.modalAdd.S_wallet,
      simbolSelect: "",
      aliasSelect: "",
      passwordSelect: "",
      twofaSelect: "",
      wallets: [],
      coins: [],
      planInfo: [],
      coinsInfo: [],
      search: "",
      paginaActual: 1,
      numeroFilas: 25,
      walletsFaltants: 0,
      balance_virtual: 0,
      balance_virtual_mxn: 0,
      dataLength: 0,
      showLoad: false,
      ClientInfo: {},
      dataContract: {},
      lan: localStorage.getItem("lan") ? localStorage.getItem("lan") : "es",
      clabe: "",
      stp_available: false,
    };
    this.getWallets = this.getWallets.bind(this);
    this.refresher = this.refresher.bind(this);
    this.handleShowTransfer = this.handleShowTransfer.bind(this);
    this.handleShowRequestTransfer = this.handleShowRequestTransfer.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }

  componentWillMount() {
    this.getWallets(
      this.state.paginaActual,
      this.state.numeroFilas,
      this.state.search
    );
    this.getCoins();
    this.getGroupPlanInfo();
    this.GetInformation();
    this.getCLABE();
    if (localStorage.getItem("vexchange") === "enabled") {
      this.get_balance_virtual();
    }
  }

  searchWallet() {
    const self = this;
    self.setState({ wallets: [] });
    self.getWallets(1, this.state.numeroFilas, this.state.search);
  }

  handleKeyPress = (event) => {
    if (event.key === "Enter") {
      this.searchWallet();
    }
  };

  refresher() {
    this.getWallets(
      this.state.paginaActual,
      this.state.numeroFilas,
      this.state.search
    );
    this.getGroupPlanInfo();
    this.setState({
      coinSelect: this.props.traductions.wallets.Index.modalAdd.S_wallet,
      simbolSelect: "",
      aliasSelect: "",
      passwordSelect: "",
      twofaSelect: "",
    });
  }

  handleClose() {
    this.setState({
      showModalRequestTransfer: false,
      showModalTransfer: false,
      showModal: false,
      showContract: false,
      showRenewAlert: false,
      passwordSelect: "",
    });
  }

  handleShow() {
    this.setState({
      showModal: true,
    });
  }

  handleShowTransfer() {
    this.setState({
      showModalTransfer: true,
    });
  }

  handleShowRequestTransfer() {
    this.setState({
      showModalRequestTransfer: true,
    });
  }

  handleCoin(valueCoin, valueSymbol) {
    this.setState({
      coinSelect: valueCoin,
      simbolSelect: valueSymbol,
    });
  }

  addNotification(title, message, type) {
    store.addNotification({
      title,
      message,
      type,
      insert: "top",
      container: "top-right",
      animationIn: ["animated", "fadeIn"],
      animationOut: ["animated", "fadeOut"],
      dismiss: {
        duration: 1800,
        onScreen: true,
      },
    });
  }
  getGroupPlanInfo() {
    const self = this;

    let date = new Date(),
      confirmation = Connection.Uwx6GVhZ(),
      result = "",
      combination = Connection.RThzHrsb("XCHF101"),
      latitude = "0",
      longitude = "0";
    navigator.geolocation.getCurrentPosition((success, error, options) => {
      latitude = success.coords.latitude;
      longitude = success.coords.longitude;
    });
    result = latitude + longitude;
    Connection.EZcga8qH(
      confirmation,
      date,
      result,
      "XL7FefG",
      combination,
      "XCHF101",
      (response) => {
        Backend.GroupInformationPlanInfo(
          localStorage.getItem("email"),
          localStorage.getItem("token"),
          response.payload.r01,
          (response) => {
            if (response.status.code === "0") {
              self.setState({
                planInfo: response.payload.plan,
                coinsInfo: response.payload.coins,
              });
            } else {
              store.addNotification({
                title: "Error!",
                message: response.status.description,
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                  duration: 1800,
                  onScreen: true,
                },
              });
            }
          }
        );
        Backend.availableCoins_rt(
          localStorage.getItem("token"),
          response.payload.r01,
          localStorage.getItem("email"),
          (response) => {
            this.setState({ coinArr: response.payload });
          }
        );
      }
    );
  }

  uploadContract(contract) {
    this.setState({ loading: true });

    let file = {
      base64Type: "pdf",
      base64: contract,
    };

    let date = new Date(),
      confirmation = Connection.Uwx6GVhZ(),
      result = "",
      combination = Connection.RThzHrsb("XCHF101"),
      latitude = "0",
      longitude = "0";
    navigator.geolocation.getCurrentPosition((success, error, options) => {
      latitude = success.coords.latitude;
      longitude = success.coords.longitude;
    });

    result = latitude + longitude;

    Connection.EZcga8qH(
      confirmation,
      date,
      result,
      "XL7FefG",
      combination,
      "XCHF101",
      (response) => {
        Backend.upload_file(
          localStorage.getItem("email"),
          localStorage.getItem("token"),
          file,
          "f_contract",
          response.payload.r01,
          (response) => {
            if (response.status.code === "0") {
              this.addNotification("Success!", "Signed contract", "success");
              this.setState({ showContract: false });
            } else {
              this.addNotification(
                "Error!",
                response.status.description,
                "danger"
              );
            }
            this.setState({ loading: false });
          }
        );
      }
    );
  }
  getWallets(value_paginaActual, value_numeroFilas, valueSearch) {
    const self = this;

    let date = new Date(),
      confirmation = Connection.Uwx6GVhZ(),
      result = "",
      combination = Connection.RThzHrsb("XCHF101"),
      latitude = "0",
      longitude = "0";
    navigator.geolocation.getCurrentPosition((success, error, options) => {
      latitude = success.coords.latitude;
      longitude = success.coords.longitude;
    });
    result = latitude + longitude;
    Connection.EZcga8qH(
      confirmation,
      date,
      result,
      "XL7FefG",
      combination,
      "XCHF101",
      (response) => {
        Backend.GetWallets(
          localStorage.getItem("email"),
          localStorage.getItem("token"),
          valueSearch,
          1,
          1000,
          response.payload.r01,
          (response) => {
            if (response.status.code === "0") {
              if (valueSearch !== "") {
                let filter_wallets = response.payload.filter(
                  (wallet) =>
                    wallet.coin === valueSearch || wallet.alias === valueSearch
                );
                self.setState({
                  wallets: filter_wallets,
                  dataLength: filter_wallets.length / value_numeroFilas,
                });
              } else {
                self.setState({
                  wallets: response.payload,
                });
              }
            } else {
              store.addNotification({
                title: "Error!",
                message: response.status.description,
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                  duration: 1800,
                  onScreen: true,
                },
              });
            }
          }
        );
      }
    );
  }

  getCoins() {
    const self = this;
    Backend.DropdownCoin((response) => {
      if (response.status.code === "0") {
        self.setState({
          coins: response.payload,
        });
      }
    });
  }

  GetInformation = () => {
    let date = new Date(),
      confirmation = Connection.Uwx6GVhZ(),
      result = "",
      combination = Connection.RThzHrsb("XCHF101"),
      latitude = "0",
      longitude = "0";

    navigator.geolocation.getCurrentPosition((success, error, options) => {
      latitude = success.coords.latitude;
      longitude = success.coords.longitude;
    });

    result = latitude + longitude;

    Connection.EZcga8qH(
      confirmation,
      date,
      result,
      "XL7FefG",
      combination,
      "XCHF101",
      (response) => {
        Backend.get_client_data(
          localStorage.getItem("email"),
          localStorage.getItem("token"),
          response.payload.r01,
          (response) => {
            localStorage.setItem("type", response.payload.client_info.type);
            if (response.status.code == "0") {
              let ClientInfo = response.payload.client_info;
              localStorage.setItem("user_name", ClientInfo.first_name);
              localStorage.setItem(
                "user_first_last_name",
                ClientInfo.last_name_p
              );
              localStorage.setItem(
                "user_second_last_name",
                ClientInfo.last_name_m
              );
              if (ClientInfo?.country == "Mexico")
                localStorage.setItem("mx", "true");
              let nombre, rfc, direccion;
              nombre = `${ClientInfo.first_name} ${ClientInfo.last_name_p} ${ClientInfo.last_name_m}`;
              rfc = ClientInfo.rfc;
              direccion = `${ClientInfo.address_street} ${ClientInfo.address_number_ext}, ${ClientInfo.address_distric}, ${ClientInfo.address_municipality}, ${ClientInfo.address_state}, ${ClientInfo.address_country}`;
              this.setState({
                ClientInfo,
                dataContract: {
                  Nombre: nombre,
                  ID_RFC: rfc,
                  Direccion: direccion,
                },
                showRenewAlert: ClientInfo.f_contract == "renew",
              });
              if (
                response.payload.client_info.lang_choosen != "-" &&
                response.payload.client_info.lang_choosen !=
                  localStorage.getItem("lan")
              )
                this.props.changeLan(response.payload.client_info.lang_choosen);
            }
          }
        );
      }
    );
  };

  getCLABE = () => {
    let date = new Date(),
      confirmation = Connection.Uwx6GVhZ(),
      result = "",
      combination = Connection.RThzHrsb("XCHF101");

    result = 0;

    Connection.EZcga8qH(
      confirmation,
      date,
      result,
      "XL7FefG",
      combination,
      "XCHF101",
      (response) => {
        let payload = response.payload;

        Backend.getClabeForSTP(payload.r01, (res) => {
          this.setState({
            clabe: res.payload.stp_clave,
            stp_available: res.payload.stp_available,
          });
        });
      }
    );
  };

  renderListWallets() {
    const self = this;
    var users = [];
    self.state.wallets.forEach(function (row) {
      var result = self.renderListCoins(row.coin);
      var balance_usd = row.balance_usd || 0;
      users.push(
        <tr
          className="hover-tr-table-wallets-generals"
          onClick={() => {
            self.redirectInformationWallet(row.id_wallet, row.coin);
          }}
        >
          <th className="table-wallet-text-result">
            <Image
              src={require("../../CryptoIcons/" + row.coin + ".svg")}
              className="icon-crypto-svg"
            />{" "}
            {result}{" "}
          </th>
          <th className="table-wallet-text-alias">{row.alias}</th>
          <th className="table-wallet-text-balance">{row.balance}</th>
          <th className="table-wallet-text-balance">
            {formatMoney(balance_usd)}
          </th>
          <th className="table-wallet-text-date">{row.created_date}</th>
        </tr>
      );
    });
    return users;
  }

  renderListCoins(value) {
    var item;
    this.state.coins.forEach((element) => {
      if (element.symbol.toLowerCase() === value.toLowerCase()) {
        item = element.name;
      }
    });
    return item;
  }

  redirectInformationWallet(value, wallet) {
    this.props.data.history.push(
      "/wallets/information?id=" + value + "&coin=" + wallet
    );
  }

  renderListCoinsDropdowns() {
    const self = this;
    var items = [];
    for (let i = 0; i < self.state.coins.length; i++) {
      const element = self.state.coins[i];
      items.push(
        <Dropdown.Item
          onClick={() => {
            this.handleCoin(element.name, element.symbol);
          }}
          as="button"
        >
          <Image
            style={{ width: 20 }}
            src={require("../../CryptoIcons/" + element.symbol + ".svg")}
          />
          {element.name}
        </Dropdown.Item>
      );
    }
    return items;
  }

  createWallet() {
    const self = this;
    var w_restant = self.walletFaltants();
    self.setState({ clabe: { showLoad: true } });

    if (
      this.state.passwordSelect !== "" &&
      this.state.simbolSelect !== "" &&
      this.state.aliasSelect !== ""
    ) {
      if (w_restant < Number(self.state.planInfo.wallets_per_coin)) {
        let whiskas = Connection.RThzHrsb(self.state.passwordSelect);
        let combination2 = Connection.RThzHrsb("XWBX203");
        let date = new Date(),
          confirmation = Connection.Uwx6GVhZ(),
          result = "",
          combination = Connection.RThzHrsb("XCHF101"),
          latitude = "0",
          longitude = "0";
        navigator.geolocation.getCurrentPosition((success, error, options) => {
          latitude = success.coords.latitude;
          longitude = success.coords.longitude;
        });
        result = latitude + longitude;
        Connection.EZcga8qH(
          confirmation,
          date,
          result,
          "XL7FefG",
          combination,
          "XCHF101",
          (response) => {
            var charly = response.payload.r01;

            Connection.QCJQ7DUk(
              confirmation,
              date,
              result,
              "Apxm2aZ",
              combination2,
              "XWBX203",
              "2",
              whiskas,
              (response) => {
                Backend.CreateWallets(
                  localStorage.getItem("email"),
                  localStorage.getItem("token"),
                  this.state.simbolSelect,
                  this.state.aliasSelect,
                  response.payload.r03,
                  charly,
                  (response) => {
                    if (response.status.code === "0") {
                      self.handleClose();
                      self.refresher();
                      store.addNotification({
                        title: "Success!",
                        message: "Wallet has been added",
                        type: "success",
                        insert: "top",
                        container: "top-right",
                        animationIn: ["animated", "fadeIn"],
                        animationOut: ["animated", "fadeOut"],
                        dismiss: {
                          duration: 1800,
                          onScreen: true,
                        },
                      });
                      self.setState({ showLoad: false });
                    } else {
                      store.addNotification({
                        title: "Error!",
                        message: response.status.description,
                        type: "danger",
                        insert: "top",
                        container: "top-right",
                        animationIn: ["animated", "fadeIn"],
                        animationOut: ["animated", "fadeOut"],
                        dismiss: {
                          duration: 1800,
                          onScreen: true,
                        },
                      });
                      self.setState({ showLoad: false });
                    }
                  }
                );
              }
            );
          }
        );
      } else {
        store.addNotification({
          title: "Error!",
          message: "The account has reached the max amount of wallets",
          type: "danger",
          insert: "top",
          container: "top-right",
          animationIn: ["animated", "fadeIn"],
          animationOut: ["animated", "fadeOut"],
          dismiss: {
            duration: 1800,
            onScreen: true,
          },
        });
        self.setState({ showLoad: false });
      }
    } else {
      store.addNotification({
        title: "Error!",
        message: "Verify information, fields cannot be empty",
        type: "danger",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: {
          duration: 1800,
          onScreen: true,
        },
      });
      self.setState({ showLoad: false });
    }
  }

  changePage(value) {
    const self = this;
    self.setState({
      paginaActual: value,
    });
    self.getWallets(value, self.state.numeroFilas, "");
  }

  renderListCardsCoinsInfo() {
    const self = this;
    var array = [];
    self.state.coinsInfo.forEach(function (row) {
      var result = self.renderListCoins(row.coin);
      array.push(
        <AccountOverviewComponent
          row={row}
          getWallets={self.getWallets}
          planInfo={self.state.planInfo}
          result={result}
          traductions={self.props.traductions.wallets.Index}
        />
      );
    });
    return array;
  }

  walletFaltants() {
    const self = this;
    var result = 0;
    self.state.coinsInfo.forEach(function (row) {
      if (self.state.simbolSelect !== "") {
        if (row.coin === self.state.simbolSelect) {
          result = row.wallets;
        }
      }
    });
    return result;
  }

  get_balance_virtual() {
    const self = this;

    let date = new Date(),
      confirmation = Connection.Uwx6GVhZ(),
      result = "",
      combination = Connection.RThzHrsb("XCHF101"),
      latitude = "0",
      longitude = "0";
    navigator.geolocation.getCurrentPosition((success, error, options) => {
      latitude = success.coords.latitude;
      longitude = success.coords.longitude;
    });
    result = latitude + longitude;
    Connection.EZcga8qH(
      confirmation,
      date,
      result,
      "XL7FefG",
      combination,
      "XCHF101",
      (response) => {
        Backend.BalanceVirtualExchange(
          localStorage.getItem("email"),
          localStorage.getItem("token"),
          response.payload.r01,
          (response) => {
            if (response.status.code === "0") {
              self.setState({
                balance_virtual: response.payload[0].balance,
                balance_virtual_mxn: response.payload[1].balance,
              });
            } else {
              store.addNotification({
                title: "Error!",
                message: response.status.description,
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                  duration: 1800,
                  onScreen: true,
                },
              });
            }
          }
        );
      }
    );
  }

  searchTimeout() {
    const self = this;
    if (searchTimeout) clearTimeout(searchTimeout);
    searchTimeout = setTimeout(function () {
      self.searchWallet();
      searchTimeout = null;
    }, 1000);
  }

  render() {
    return (
      <div>
        <NavbarComponent data={this.props} selected="wallets" logged={true} />
        <RenovateTokenAlert data={this.props} />
        <ChangePlanAlert
          data={this.props}
          userPlan={this.state.planInfo.name}
        />
        <div className="contenedor-wallets-generals">
          <Container fluid>
            <PlanInformationComponent
              ClientInfo={this.state.ClientInfo}
              data={this.props.data}
              coinsInfo={this.state.coinsInfo}
              planInfo={this.state.planInfo}
              balance_virtual={this.state.balance_virtual}
              traductions={this.props.traductions.wallets.Index}
            />
            <Row>
              <Col md={12} lg={{ span: 4, offset: 1 }}>
                <div className="container-cards-wallets-generals">
                  <div className="border-title-separator-container">
                    <div
                      className="border-title-separator-container-left"
                      style={{ width: "100%" }}
                    >
                      <p className="title-container-shadow">
                        {this.props.traductions.wallets.Index.Account_overview}
                      </p>
                    </div>
                  </div>
                  <div
                    style={{ height: "calc(100vh - 293px)" }}
                    className="scroll-table-wallets-generals"
                  >
                    {
                      <>
                        <div style={{ paddingLeft: 5 }}>
                          <div className="container_card_content_wallets_addresses">
                            <div className="container_card_content_display_flex">
                              <div className="container_card_content_icon_wallet">
                                <Image
                                  src={require("../../CryptoIcons/usd.svg")}
                                  style={{ width: 40 }}
                                />
                              </div>
                              <div className="container_card_content_name_wallet_prices">
                                <p className="container_card_content_name_text_wallet_prices">
                                  ${this.state.balance_virtual} USD
                                </p>
                                <p className="container_card_content_name_text_wallet_balance">
                                  {" "}
                                  <span>Virtual USD</span> Balance{" "}
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div style={{ paddingLeft: 5 }}>
                          <div className="container_card_content_wallets_addresses">
                            <div className="container_card_content_display_flex_stp">
                              <div className="container_card_content_icon_wallet">
                                <Image
                                  src={require("../../CryptoIcons/vmxn.svg")}
                                  style={{ width: 40 }}
                                />
                              </div>
                              <div className="container_card_content_name_wallet_prices">
                                <p className="container_card_content_name_text_wallet_prices">
                                  ${this.state.balance_virtual_mxn} MXN
                                </p>
                                <p className="container_card_content_name_text_wallet_balance">
                                  {" "}
                                  <span>Virtual MXN</span> Balance{" "}
                                </p>
                              </div>
                              {this.state.stp_available && (
                                <button
                                  className="container_card_content_button"
                                  onClick={() =>
                                    this.setState({ showModalSTP: true })
                                  }
                                >
                                  <Image
                                    style={{ marginLeft: "5px" }}
                                    src={TransactionArrow}
                                    width={10}
                                  />
                                  {translateWallet[this.state.lan].STPModal.stpButton}
                                </button>
                              )}
                            </div>
                          </div>
                        </div>
                      </>
                    }
                    {this.renderListCardsCoinsInfo()}
                  </div>
                </div>
              </Col>
              <Col md={12} lg={6}>
                <div className="container-cards-wallets-generals">
                  <div className="border-title-separator-container">
                    <div className="border-title-separator-container-left">
                      <p className="title-container-shadow">
                        {this.props.traductions.wallets.Index.My_Wallets}
                      </p>
                    </div>
                    <div className="border-title-separator-container-right">
                      {localStorage.getItem("mx") && (
                        <Button
                          className="wirebit-transfer-generals-button"
                          variant="primary"
                          onClick={() => {
                            this.props.data.history.push("/services");
                          }}
                        >
                          {this.props.traductions.services.title}
                        </Button>
                      )}
                      <Button
                        className="wirebit-transfer-generals-button"
                        variant="primary"
                        onClick={() => {
                          this.handleShowTransfer();
                        }}
                      >
                        {this.props.traductions.wallets.Index.btn_transfer}
                      </Button>
                      <Button
                        className="wirebit-transfer-generals-button"
                        variant="primary"
                        onClick={() => {
                          this.handleShowRequestTransfer();
                        }}
                      >
                        {this.props.traductions.wallets.Index.btn_Stransfer}
                      </Button>
                      <Button
                        className="wirebit-transfer-generals-button"
                        variant="primary"
                        onClick={() => {
                          this.handleShow();
                        }}
                      >
                        {this.props.traductions.wallets.Index.btn_AddWallet}
                      </Button>
                    </div>
                  </div>
                  <div
                    style={{ height: "calc(100vh - 377px)" }}
                    className="scroll-table-wallets-generals"
                  >
                    <div className="container-botonera-wallets-generals">
                      <div className="botonera-wallets-generals-left">
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            position: "relative",
                          }}
                        >
                          <div style={{ position: "relative" }}>
                            <Form.Control
                              onKeyDown={() => {
                                this.searchTimeout();
                              }}
                              className="input-search-wallets-generals"
                              autocomplete="no"
                              type="search"
                              placeholder={
                                this.props.traductions.wallets.Index
                                  .input_search
                              }
                              value={this.state.search}
                              onKeyPress={this.handleKeyPress}
                              onChange={(search) => {
                                this.setState({ search: search.target.value });
                              }}
                            />
                            <Image
                              src={SearchImage}
                              className="searchImage"
                              style={{ width: 20 }}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="botonera-wallets-generals-right">
                        <Image
                          src={RefreshImage}
                          onClick={() => {
                            this.getWallets(1, 10, "");
                          }}
                          style={{ width: 20, cursor: "pointer" }}
                        />
                      </div>
                    </div>
                    <table className="table-container-wallets-generals">
                      <thead>
                        <tr>
                          <th className="header-table-wallets-generals fixxxed">
                            {this.props.traductions.wallets.Index.t_h_coin}
                          </th>
                          <th className="header-table-wallets-generals fixxxed">
                            {this.props.traductions.wallets.Index.t_h_alias}
                          </th>
                          <th className="header-table-wallets-generals fixxxed align-text-right">
                            {this.props.traductions.wallets.Index.t_h_balance}
                          </th>
                          <th className="header-table-wallets-generals fixxxed align-text-right">
                            {
                              this.props.traductions.wallets.Index
                                .t_h_balanceAprox
                            }
                          </th>
                          <th className="header-table-wallets-generals fixxxed align-text-right">
                            {this.props.traductions.wallets.Index.t_h_date}
                          </th>
                        </tr>
                      </thead>
                      <tbody>{this.renderListWallets()}</tbody>
                    </table>
                  </div>
                  {/* <div style={{ display: "flex", justifyContent: "center", alignItems: "center", marginTop: 20 }}> */}
                  {/* <DropdownButton id="dropdown-item-button-step1" title={this.state.numeroFilas}>
                      <Dropdown.Item onClick={() => { this.setState({ numeroFilas: 25 }); this.getWallets(1, 25, this.state.search); }} as="button">25</Dropdown.Item>
                      <Dropdown.Item onClick={() => { this.setState({ numeroFilas: 50 }); this.getWallets(1, 50, this.state.search); }} as="button">50</Dropdown.Item>
                      <Dropdown.Item onClick={() => { this.setState({ numeroFilas: 100 }); this.getWallets(1, 100, this.state.search); }} as="button">100</Dropdown.Item>
                    </DropdownButton> */}

                  {/* <Pagination>
                      <Pagination.First disabled={this.state.paginaActual === 1 || this.state.spinner} onClick={() => {
                        if (this.state.paginaActual !== 0) {
                          this.changePage(1);
                        }
                      }} />
                    <a className={(this.state.paginaActual == 1 || this.state.spinner)?'page-link disabled':'page-link'} onClick={() => {
                        if (this.state.paginaActual !== 1 && !this.state.spinner) {
                          this.changePage(this.state.paginaActual - 1);
                        }
                      }}> {this.props.traductions.wallets.Index.btn_prev} </a>

                      {this.state.paginaActual > 2 &&
                        <Pagination.Item disabled={this.state.spinner} onClick={() => { this.changePage(this.state.paginaActual - 2) }}>{this.state.paginaActual - 2}</Pagination.Item>
                      }
                      {this.state.paginaActual > 1 &&
                        <Pagination.Item disabled={this.state.spinner} onClick={() => { this.changePage(this.state.paginaActual - 1) }}>{this.state.paginaActual - 1}</Pagination.Item>
                      }
                      <Pagination.Item active>{this.state.paginaActual}</Pagination.Item>
                      {this.state.paginaActual < this.state.dataLength &&
                        <Pagination.Item disabled={this.state.spinner} onClick={() => { this.changePage(this.state.paginaActual + 1) }}>{this.state.paginaActual + 1}</Pagination.Item>
                      }
                      {this.state.paginaActual < this.state.dataLength - 1 &&
                        <Pagination.Item disabled={this.state.spinner} onClick={() => { this.changePage(this.state.paginaActual + 2) }}>{this.state.paginaActual + 2}</Pagination.Item>
                      }
                      <a className={(this.state.paginaActual >= this.state.dataLength || this.state.spinner)?'page-link disabled':'page-link'}  onClick={() => {
                        if (this.state.paginaActual < this.state.dataLength && !this.state.spinner) {
                          this.changePage(this.state.paginaActual + 1)
                        }
                      }}> {this.props.traductions.wallets.Index.btn_next} </a>

                      <Pagination.Last disabled={this.state.paginaActual >= this.state.dataLength || this.state.spinner} onClick={() => {
                        if (this.state.paginaActual < this.state.dataLength) {
                          this.changePage(this.state.dataLength)
                        }
                      }} />
                    </Pagination> */}
                  {/* </div> */}
                </div>
              </Col>
            </Row>
          </Container>
        </div>

        <Modal
          className="modal-signup-resend-email"
          centered
          aria-labelledby="contained-modal-title-vcenter"
          show={this.state.showRenewAlert}
          onHide={() => {
            this.handleClose();
          }}
        >
          <Modal.Body>
            <div>
              <p className="title-container-shadow center-text">
                {this.props.traductions.wallets.Index.modalContract.title}
              </p>
              <p
                className="add-wallets-generals-restant-wallets"
                style={{ marginBottom: 10 }}
              >
                {this.props.traductions.wallets.Index.modalContract.text}
              </p>
              <div style={{ textAlign: "center" }}>
                <Button
                  className="steps-button-wallet-general"
                  style={{ backgroundColor: "#053164" }}
                  onClick={() => {
                    this.setState({
                      showContract: true,
                      showRenewAlert: false,
                    });
                  }}
                >
                  {this.props.traductions.wallets.Index.modalContract.continue}
                </Button>
              </div>
            </div>
          </Modal.Body>
        </Modal>

        <Contract
          show={this.state.showContract}
          handleClose={() => this.handleClose()}
          data={this.state.dataContract}
          uploadContract={(contract) => this.uploadContract(contract)}
          Loading={this.state.loading}
          traductions={this.props.traductions}
        />

        <Modal
          className="modal-signup-resend-email"
          centered
          aria-labelledby="contained-modal-title-vcenter"
          show={this.state.showModal}
          onHide={() => {
            this.handleClose();
            if(this.props.data.history){
              this.props.data.history.replace(this.props.data.history.location.pathname, { modal_wallet: false });
            }
          }}
        >
          <Modal.Body>
            <div>
              <p className="title-container-shadow center-text">
                {this.props.traductions.wallets.Index.modalAdd.title}
              </p>
            </div>
            <div className="container-steps-add-wallet-general">
              <div className="steps-add-wallet-general">
                <Form.Group as={Row}>
                  <Form.Label column sm="2" className="label-modal">
                    {this.props.traductions.wallets.Index.modalAdd.wallet}
                  </Form.Label>
                  <Col sm="10">
                    <DropdownButton title={this.state.coinSelect}>
                      {this.renderListCoinsDropdowns()}
                    </DropdownButton>
                    <p className="add-wallets-generals-restant-wallets">
                      {this.props.traductions.wallets.Index.modalAdd.wallet}s:{" "}
                      {this.walletFaltants()} /{" "}
                      {this.state.planInfo.wallets_per_coin}
                    </p>
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm="2" className="label-modal">
                    {this.props.traductions.wallets.Index.modalAdd.L_Alias}
                  </Form.Label>
                  <Col sm="10">
                    <Form.Control
                      className="input-modal"
                      type="text"
                      placeholder={
                        this.props.traductions.wallets.Index.modalAdd.P_Alias
                      }
                      value={this.state.aliasSelect}
                      onChange={(aliasSelect) => {
                        this.setState({
                          aliasSelect: aliasSelect.target.value,
                        });
                      }}
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm="2" className="label-modal">
                    {this.props.traductions.wallets.Index.modalAdd.L_Pass}
                  </Form.Label>
                  <Col sm="10">
                    <Form.Control
                      className="input-modal"
                      type="password"
                      id="field2"
                      placeholder="********"
                      autoComplete="new-password"
                      value={this.state.passwordSelect}
                      onChange={(passwordSelect) => {
                        this.setState({
                          passwordSelect: passwordSelect.target.value,
                        });
                      }}
                    />
                    <label
                      style={{
                        marginBottom: 0,
                        fontSize: 15,
                        color: "#8E95AB",
                      }}
                    >
                      {this.props.traductions.wallets.Index.modalAdd.N_Pass}
                    </label>
                  </Col>
                </Form.Group>
                <Form.Group style={{ marginTop: 70 }}>
                  <Button
                    className="steps-button-wallet-general"
                    style={{ backgroundColor: "#053164" }}
                    onClick={() => {
                      this.createWallet();
                    }}
                    disabled={this.state.showLoad}
                  >
                    {this.state.showLoad ? (
                      <Bounce
                        size={20}
                        color={"#FFFFFF"}
                        animating={this.state.showLoad}
                      />
                    ) : (
                      this.props.traductions.wallets.Index.modalAdd.btn
                    )}
                  </Button>
                </Form.Group>
              </div>
            </div>
          </Modal.Body>
        </Modal>

        <STPModal
          show={this.state.showModalSTP}
          close={() => this.setState({ showModalSTP: false })}
          language={this.state.lan}
          clabe={this.state.clabe}
        />

        {this.state.planInfo != "" && (
          <TransferModal
            {...this.state}
            {...this.props}
            refresher={this.refresher}
            showModalTransfer={this.state.showModalTransfer}
            handleShowTransfer={this.handleShowTransfer}
            handleClose={this.handleClose}
          />
        )}
        <RequestTranferModal
          traductions={this.props.traductions.wallets.Index}
          {...this.state}
          refresher={this.refresher}
          showModalRequestTransfer={this.state.showModalRequestTransfer}
          handleShowRequestTransfer={this.handleShowRequestTransfer}
          handleClose={this.handleClose}
        />
      </div>
    );
  }
}
export default WalletsIndex;
